<template>
  <div class="delete-user">
    <div v-on:click="showDeleteUserPopup" class="delete-user-title">Slet konto</div>
    <pure-modal v-if="showDeleteUser" v-on:close="showDeleteUser = false">
      <template v-slot:header>
        <div class="main-title">
          <h2>Slet konto</h2>
        </div>
        <form v-on:submit.prevent="deleteUser(userInfo)">
          <ul>
            <li class="checkbox-field" :class="{error: validation.delete}">
              <input-checkbox v-bind:value="confirmation" v-on:input="confirmation = $event" :validation="validation.delete" label="Dine profil og oplysninger data vil blive slettet, ligesom du ikke længere fremadrettet vil optjene cashback hos nuværende samt kommende deltagende butikker og webshops. " id="confirmation" :dataInput="'confirmation-' + Math.floor(Math.random() * 100)"></input-checkbox>
            </li>
          </ul>
          <div class="btn-box">
            <input type="submit" :class="{loading: loading}" class="update-btn" value="Bekræft sletning" />
            <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
            <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
          </div>
        </form>
      </template>
    </pure-modal>
  </div>
</template>

<script>
import InputCheckbox from '../Inputs/Checkbox'
import {PureModal} from 'vue-pure-modal'
import 'vue-pure-modal/dist/puremodal.css'

export default {
  name: 'DeleteUser',

  props: {
    userInfo: {
      type: Object,
      default: {},
    },
  },

  components: {
    'pure-modal': PureModal,
    'input-checkbox': InputCheckbox,
  },

  data() {
    return {
      showDeleteUser: false,
      successMessage: null,
      errorMessage: null,
      loading: false,
      confirmation: null,
      validation: {},
    }
  },

  methods: {
    showDeleteUserPopup() {
      this.showDeleteUser = true
    },

    deleteUser(userInfo) {
      this.loading = true

      if (!this.confirmation) {
        this.loading = false
        this.validation.delete = 'Venligst bekræft dit valg'
        return
      }

      let redirect = '/'

      fetch('/authenticate/delete', {
        method: 'DELETE',
        redirect: 'follow',
        body: JSON.stringify({
          nonce: this.$settings.nonce,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.statusText)
          }

          redirect = response.url

          return this.$cashback.userDelete(userInfo)
        })
        .then((response) => {
          window.location.href = redirect
        })
        .catch((err) => {
          this.loading = false
          this.errorMessage = 'Bruger kunne ikke slettes'
        })
    },
  },
}
</script>
